import Vue from 'vue'
import Vuex from 'vuex'
import VuexPersistence from 'vuex-persist'
import user from './modules/user'
import menu from './modules/menu'
import sku from './modules/sku'
import qwAuth from './modules/qwAuth'
import getters from './getters'

Vue.use(Vuex)
// vuex持久化
const vuexLocal = new VuexPersistence({
  key: '__presist',
  storage: window.localStorage,
  modules: ['user']
})

const store = new Vuex.Store({
  modules: {
    menu,
    user,
    sku,
    qwAuth
  },
  getters,
  plugins: [vuexLocal.plugin]
})

export default store
